import { Injectable } from '@angular/core';
import { LocalStorageService } from 'angular-2-local-storage';
import { Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

@Injectable()
export class HandleError {
    constructor(
        private authService: AuthService
    ) {

    }

    public newError(error, url, data) {
        switch (error.status) {
            case 404:
                location.reload();
                break;
            case 403:
                this.authService.logout();
            break;
        }
    }
}